import { Breadcrumb, ProjectForm } from '@common';
import useUpdateProject from './useUpdateProject';

export function EditApp() {
    const { onFinish, form, detailsLoading, updateLoading, currentAppName } = useUpdateProject();

    return (
        <>
            <Breadcrumb breadcrumbNameChangeMap={{ ':name': currentAppName as string }} />

            <ProjectForm
                form={form}
                isLoading={detailsLoading || updateLoading}
                onFinish={onFinish}
                currentAppName={currentAppName}
            />
        </>
    );
}
